@if (entry.base?.display) {
  <form [formGroup]="form" [connect]="'payloadStates.' + entry?.formControlAttributes.connectPath" class="event-form">
    <!--Dropdown for life events-->
    <mat-form-field appearance="outline" class="event">
      <mat-label>{{entry?.formControlAttributes?.label}}</mat-label>
      <mat-select aria-label="Qualifying Life Event" [formControlName]="entry?.formControlAttributes?.formControlName" [compareWith]="compareWithFn" (selectionChange)="selectionChange($event.value)">
        @for (lifeEvent of qualifyingLifeEvents; track lifeEvent) {
          <mat-option [value]="lifeEvent">
            {{lifeEvent.lifeEventDescription}}
          </mat-option>
        }
      </mat-select>
      @if (formControls[entry?.formControlAttributes?.formControlName]?.errors?.required) {
        <mat-error>Required</mat-error>
      }
    </mat-form-field>
  </form>
}